import moment from 'moment';
import * as fileService from '../services/fileService';
import {
  FILE_LOADING, ADD_FILE, MOVE_FILE, GET_FILE, GET_PUBLIC_FILE, EDIT_FILE, EDIT_VISIBILITY, DELETE_FILE,
  GET_ONSITE_FILE, GET_SHARED_FILE, STORE_FILE_TAGS,
} from '../reducers/fileReducer';

export const getFile = () => (dispatch) => {
  dispatch({type: FILE_LOADING, payload: true});
  fileService.getFile()
    .then(result => {
      dispatch({type: GET_FILE, payload: result.data});
    })
    .catch((error) => console.log(error))
    .finally(() => dispatch({type: FILE_LOADING, payload: false}));
}

export const getPublicFiles = (folderID) => (dispatch) => {
  dispatch({type: FILE_LOADING, payload: true});
  fileService.getPublicFiles(folderID)
    .then(result => {
      dispatch({type: GET_PUBLIC_FILE, payload: result.data});
    })
    .catch((error) => console.log(error))
    .finally(() => dispatch({type: FILE_LOADING, payload: false}));
}

export const getOnSiteFiles = (folderID) => (dispatch) => {
  dispatch({type: FILE_LOADING, payload: true});
  fileService.getOnSiteFiles(folderID)
    .then(result => {
      dispatch({type: GET_ONSITE_FILE, payload: result.data});
    })
    .catch((error) => console.log(error))
    .finally(() => dispatch({type: FILE_LOADING, payload: false}));
}

export const getSharedFiles = (folderID) => (dispatch) => {
  dispatch({type: FILE_LOADING, payload: true});
  fileService.getSharedFiles(folderID)
    .then(result => {
      dispatch({type: GET_SHARED_FILE, payload: result.data});
    })
    .catch((error) => console.log(error))
    .finally(() => dispatch({type: FILE_LOADING, payload: false}));
}

export const getFileTags = () => (dispatch) => {
  dispatch({type: FILE_LOADING, payload: true});
  fileService.getFileTags()
    .then(result => {
      dispatch({type: STORE_FILE_TAGS, payload: result.data});
    })
    .catch((error) => console.log(error))
    .finally(() => dispatch({type: FILE_LOADING, payload: false}));
}

export const insertFile = (payload) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: FILE_LOADING, payload: true});
  fileService.addFile(payload)
    .then(result => {
      let {insertId: id} = result.data;
      dispatch({
        type: ADD_FILE,
        payload: {
          id,
          created: moment().format(),
          ...payload,
        }
      });
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: FILE_LOADING, payload: false}));
});

export const copyFile = (id) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: FILE_LOADING, payload: true});
  fileService.copyFile(id)
    .then(result => {
      let {data} = result;
      dispatch({
        type: ADD_FILE,
        payload: {
          ...data,
          created: moment().format(),
        }
      });
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: FILE_LOADING, payload: false}));
});

export const moveFile = (id, folder_id) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: FILE_LOADING, payload: true});
  fileService.moveFile(id, folder_id)
    .then(result => {
      dispatch({type: MOVE_FILE, payload: {id, folder_id}});
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: FILE_LOADING, payload: false}));
});

export const editFile = (data) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: FILE_LOADING, payload: true});
  fileService.editFile(data)
    .then(result => {
      dispatch({type: EDIT_FILE, payload: {...data}});
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: FILE_LOADING, payload: false}));
});

export const editVisibility = (id, is_public) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: FILE_LOADING, payload: true});
  fileService.editVisibility(id, is_public)
    .then(result => {
      dispatch({type: EDIT_VISIBILITY, payload: {id, is_public}});
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: FILE_LOADING, payload: false}));
});

export const deleteFile = (id) => (dispatch) => new Promise((resolve, reject) => {
  dispatch({type: FILE_LOADING, payload: true});
  fileService.deleteFile(id)
    .then(result => {
      dispatch({type: DELETE_FILE, payload: {id}});
      resolve();
    })
    .catch((error) => reject(error))
    .finally(() => dispatch({type: FILE_LOADING, payload: false}));
});
